module.exports = __webpack_public_path__ + "static/media/error.9850680d.png";